import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { FormGroup, FormControl } from "react-bootstrap";
import FieldError from "../../../shared/FieldError";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import Table from "../../../shared/Table";
import CprOrderRequest from "./CprOrderRequest";
import Lead from "../../../shared/Lead";
import Loading from "../../../shared/Loading";
import * as API from "../../../api";
import * as CONST from "../../../helpers/Constants";
import { Settings } from "../../../helpers/Contexts";
const CprStatusCheck = ( {task }) => {
  const settings = useContext(Settings);
  const [localTask, setLocalTask] = React.useState(task);

  // Keep in sync if parent sends a different task
  React.useEffect(() => {
    setLocalTask(task);
  }, [task]);

  const initialPromptVal = React.useMemo(() => {
    const val = localTask?.latest_quality_measurement;
    if (val === null || val === undefined) return null;
    return val === true ? "No" : "Yes";
  }, [localTask]);

  const [promptVal, setPromptVal] = React.useState(initialPromptVal);
  let [loading, setLoading] = useState(false);
  let [taskSubmitted, setTaskSubmitted] = useState(localTask.status ==  'closed');
  const history = useHistory();

  let [showDataEntry, setShowDataEntry] = React.useState(
    localTask.cpr.status == 'closed' &&
    localTask.cpr.procedure_type == 'Annual Wellness Visit'
  );

  const CprCompletedFormSchema = Yup.object().shape({
    attending_provider: Yup.string().required("Attending provider is required"),
    completed_on_date: Yup.string().required("Completed on date is required."),
    document: Yup.mixed().required("A document is required"),
  });

  const CprCompletedForm = () => {
    return(<>
      <Formik
        initialValues={{
          attending_provider: "",
          completed_on_date: "",
          document: ""
        }}
        validationSchema={CprCompletedFormSchema}
        validateOnChange={true}
        onSubmit={(values) => {
          setLoading(true);

          const formData = new FormData();

          formData.append("task[completed_on_date]", values.completed_on_date);
          formData.append("task[document]", values.document);
          formData.append("task[attending_provider]", values.attending_provider);
          formData.append("task[event]", "cpr_completed");
          formData.append("task[latest_quality_measurement]", true);
          formData.append("task[id]", localTask.id);
          return localTask.formHandler(formData);
        }}
      >

        {({ values, errors, setFieldValue, initialValues, isSubmitting }) => {

          return(<>
            <Form>
              <label>Attending Provider</label>
              <input
                className="default"
                name="attending_provider"
                onChange={(e) => setFieldValue("attending_provider", e.target.value)}
                value={
                  values.procedure_type == "Cologuard"
                    ? CONST.DEFAULT_COLOGUARD_ATTENDING_PROVIDER
                    : values.attending_provider
                }
              />
              {errors.attending_provider ? (
                <FieldError error={errors.attending_provider} />
              ) : null}
              <label>Measurement date</label>
              <div className={"flex datefield-wrapper full-width"}>
                <Field name="date">
                  {({ field, meta }) => {
                    return (
                      <>
                        <ReactDatePicker
                          {...field}
                          autoComplete="off"
                          className="datepicker"
                          maxDate={new Date()}
                          dateFormat={"YYYY-MM-dd"}
                          onChange={(date) => {
                            setFieldValue(
                              "completed_on_date",
                              new Date(date).toLocaleDateString()
                            );
                            setFieldValue("date", date.toISOString().slice(0, 10));
                          }}
                        />
                      </>
                    );
                  }}
                </Field>
              </div>
              {errors.date ? <FieldError error={errors.date} /> : null}
              <label>Attach Results/Visit Summary (If Available)</label>
              <FormGroup controlId="formFile" className="mb-3">
                <FormControl
                  type="file"
                  onChange={(e) => setFieldValue("document", e.target.files[0])}
                />
              </FormGroup>

              <button className="check accent-bg pt2" type="submit" disabled={isSubmitting}>
                Submit CPR Status Check
              </button>
            </Form>
          </>);
        }}
      </Formik>
    </>);
    };

    return (
      <div className="p1">
        <Lead message={"CPR Status Check"} />
        <br />
        <div className="pt2s m-t-lg">
          {CONST.CPR_STATUS_CHECK.BODY_1}

          {!taskSubmitted && (<>
              <br />
              <div className={'m-t-lg'}>
                {CONST.CPR_STATUS_CHECK.BODY_2}
              </div>
              <div className={'m-t-lg'}>
                <Table
                  headers={["Procedure Type", "Due Date", "Servicing Provider", "Required Frequency (required at least every)"].map((i) => (
                    <th key={i}>{i}</th>
                  ))}
                  children={
                    <tr key={localTask.cpr.id}>
                      <td>{localTask.cpr.procedure_type}</td>
                      <td>{localTask.cpr.due_date}</td>
                      <td>{localTask.cpr.servicing_provider}</td>
                      <td>{localTask.cpr.frequency_text}</td>
                    </tr>
                  }
                />
              </div>
              <br />
              <div className={'m-t-lg'}>
                <b>{CONST.CPR_STATUS_CHECK.BODY_3}</b>
              </div>
              <div className={'m-t-lg'}>
                <select
                  value={promptVal}
                  disabled={localTask.status == 'closed'}
                  onChange={(el) => {
                    let value = el.target.value == 'Yes';
                    setPromptVal(el.target.value);

                    // Patient DID NOT COMPLETE ths CPR
                    // Patient needs an order - reset order verified field.
                    if (!value) {
                      API.updateTask(localTask.id, {
                        task: {
                          id: localTask.id,
                          reset_order_document_verified: true,
                        }
                      }).then((response) => {
                        // Update the local task state so CprOrderRequest re-renders
                        setLocalTask((prev) => ({
                          ...prev,
                          cpr: {
                            ...prev.cpr,
                            order_document_verified: null,
                          },
                        }));
                      }).catch((err) => {
                        console.error("Failed to update task:", err);
                      });
                    }
                  }}
                  id={"cpr-completed-question-selector"}>
                  <option>-- Select an option --</option>
                  <option value={"Yes"}>Yes</option>
                  <option value={"No"}>No</option>
                </select>
              </div>
              <div className={"m-t-lg"}>
                <i>{CONST.CPR_STATUS_CHECK.NOTE_1}</i>
              </div>
              { !loading && (promptVal == "No" || (localTask.latest_quality_measurement == true && localTask.status == 'closed')) && <CprOrderRequest task={localTask} /> }
              { !loading && (promptVal == "Yes" || (localTask.latest_quality_measurement == false && localTask.status == 'closed')) && !taskSubmitted && <CprCompletedForm /> }
              { loading && <Loading message={""} />}
          </>)}

          {taskSubmitted && (<>
              <br />
              <b>Task has been submitted!</b>
          </>)}

          {promptVal == "2" && !showDataEntry && (
            <>
              <b>{CONST.QM_STATUS_CHECK.SELECTED_VALUE_2} </b>
              <LastMeasurementForm showDataEntry={showDataEntry} setShowDataEntry={setShowDataEntry} task={localTask}/>
            </>
          )}

        </div>
      </div>
    );
};

export default CprStatusCheck;
